import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { useSetModal } from "@/shared/atoms/useModal";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import usePosOrderCustomDiscount, {
  defaultPosOrderCustomDiscount,
} from "@/shared/atoms/usePosOrderCustomDiscount";

const usePosOrderDiscountAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const setModal = useSetModal();
  const [{ fixed_price_discount, percentage_discount }, setCustomDiscount] =
    usePosOrderCustomDiscount();

  return {
    name: "posOrderDiscount" as CurrentActionTypes,
    label: t("posOrders.addDiscount"),
    set: () => setModal("posOrderDiscount"),
    hasDeleteAction: Boolean(fixed_price_discount || percentage_discount),
    deleteAction: () => setCustomDiscount(defaultPosOrderCustomDiscount),
    instantSet: true,
    filtered: false,
    disabled: false,
    iconVariant:"percent",
  };
};

const PosOrderDiscountAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = usePosOrderDiscountAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default PosOrderDiscountAction;
